<script>
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import {Dropdown} from 'floating-vue';

export default {
  components: {
    AkButtonActionV2,
    Dropdown,
  },
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },

    information: {
      type: String,
      required: false,
      default: undefined,
    },
    labelClass: {
      type: String,
      required: false,
      default: '',
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {},
};
</script>

<template>
  <div
    :class="{'mb-2.5': !inline}"
    class="flex items-center justify-between min-h-[20px]"
    v-if="this.showLabel || information">
    <label
      v-if="this.showLabel"
      :for="id"
      class="flex-1 font-inter font-semibold text-base text-dark"
      :class="labelClass">
      <slot />
      <span class="text-red">{{ required ? ' *' : '' }}</span></label
    >
    <div class="flex gap-2 ml-2" :class="{'flex-1 justify-end': !this.showLabel}">
      <Dropdown theme="information" v-if="information">
        <!-- This will be the popover reference (for the events and position) -->
        <span
          class="ga-icon ga-question rounded-full text-gray text-sm flex items-center justify-center bg-[#F5F6F8] w-[20px] h-[20px] hover:cursor-pointer"></span>
        <!-- This will be the content of the popover -->
        <template #popper>
          <div
            class="font-inter text-gray !text-sm break-words text-pretty text-justify leading-normal"
            v-html="information"></div>
        </template>
      </Dropdown>

      <slot name="link" />
    </div>
  </div>
</template>
